var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "d-flex justify-content-end" },
        [
          _c(
            "b-button",
            {
              staticClass: "my-1",
              attrs: { variant: "primary" },
              on: { click: _vm.openAddModal },
            },
            [_vm._v(" Add Expense ")]
          ),
        ],
        1
      ),
      _c(
        "b-modal",
        {
          attrs: {
            id: "addModal",
            title: _vm.isEditMode ? "Edit Expense" : "Add Expense",
            centered: "",
            "hide-footer": "",
          },
          model: {
            value: _vm.showAddModal,
            callback: function ($$v) {
              _vm.showAddModal = $$v
            },
            expression: "showAddModal",
          },
        },
        [
          _c(
            "b-row",
            { staticClass: "justify-content-center" },
            [
              _c(
                "b-form",
                {
                  staticClass: "p-3",
                  on: {
                    submit: function ($event) {
                      $event.preventDefault()
                      return _vm.AddExpense($event)
                    },
                  },
                },
                [
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { md: "12" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              staticClass: "mb-4",
                              attrs: {
                                label: "Expense Date",
                                "label-for": "expenseDate",
                              },
                            },
                            [
                              _c("b-form-datepicker", {
                                staticClass: "form-control-custom",
                                attrs: { id: "expenseDate", required: "" },
                                model: {
                                  value: _vm.newExpense.expenseDate,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.newExpense, "expenseDate", $$v)
                                  },
                                  expression: "newExpense.expenseDate",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { md: "6" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              staticClass: "mb-4",
                              attrs: { label: "Tax", "label-for": "tax" },
                            },
                            [
                              _c(
                                "b-form-select",
                                {
                                  staticClass: "form-control-custom",
                                  attrs: {
                                    id: "tax",
                                    options: _vm.taxOptions,
                                    required: "",
                                  },
                                  model: {
                                    value: _vm.newExpense.tax,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.newExpense, "tax", $$v)
                                    },
                                    expression: "newExpense.tax",
                                  },
                                },
                                [
                                  _c(
                                    "option",
                                    {
                                      attrs: { disabled: "" },
                                      domProps: { value: null },
                                    },
                                    [_vm._v("Select a tax")]
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { md: "6" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              staticClass: "mb-4",
                              attrs: { label: "Total", "label-for": "total" },
                            },
                            [
                              _c("b-form-input", {
                                staticClass: "form-control-custom",
                                attrs: {
                                  id: "total",
                                  type: "number",
                                  step: "0.01",
                                  required: "",
                                },
                                on: { input: _vm.calculateTaxAmount },
                                model: {
                                  value: _vm.newExpense.total,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.newExpense,
                                      "total",
                                      _vm._n($$v)
                                    )
                                  },
                                  expression: "newExpense.total",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { md: "6" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              staticClass: "mb-4",
                              attrs: {
                                label: "Reference",
                                "label-for": "reference",
                              },
                            },
                            [
                              _c("b-form-input", {
                                staticClass: "form-control-custom",
                                attrs: { id: "reference", required: "" },
                                model: {
                                  value: _vm.newExpense.reference,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.newExpense, "reference", $$v)
                                  },
                                  expression: "newExpense.reference",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { md: "6" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              staticClass: "mb-4",
                              attrs: {
                                label: "Tax Amount",
                                "label-for": "taxAmount",
                              },
                            },
                            [
                              _c("b-form-input", {
                                staticClass: "form-control-custom",
                                attrs: {
                                  id: "taxAmount",
                                  readonly: "",
                                  type: "number",
                                  step: "0.01",
                                },
                                model: {
                                  value: _vm.newExpense.taxAmount,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.newExpense, "taxAmount", $$v)
                                  },
                                  expression: "newExpense.taxAmount",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { md: "12" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              staticClass: "mb-4",
                              attrs: {
                                label: "Contact",
                                "label-for": "contact",
                              },
                            },
                            [
                              _c("validation-provider", {
                                attrs: {
                                  rules: "required",
                                  name: "Contact",
                                  vid: "Contact",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (ref) {
                                      var errors = ref.errors
                                      return [
                                        _c(
                                          "b-form-select",
                                          {
                                            staticClass: "form-control-custom",
                                            attrs: {
                                              id: "contact",
                                              options: _vm.contactOptions,
                                            },
                                            model: {
                                              value: _vm.newExpense.contact,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.newExpense,
                                                  "contact",
                                                  $$v
                                                )
                                              },
                                              expression: "newExpense.contact",
                                            },
                                          },
                                          [
                                            _c(
                                              "option",
                                              {
                                                attrs: { disabled: "" },
                                                domProps: { value: null },
                                              },
                                              [_vm._v("Select a contact")]
                                            ),
                                          ]
                                        ),
                                        errors.length
                                          ? _c(
                                              "small",
                                              { staticClass: "text-danger" },
                                              [_vm._v(_vm._s(errors[0]))]
                                            )
                                          : _vm._e(),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "modal-footer d-flex justify-content-center",
                    },
                    [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-primary w-50",
                          attrs: { type: "submit" },
                        },
                        [
                          _vm.loading
                            ? _c("b-spinner", {
                                staticClass: "mx-2",
                                attrs: { small: "" },
                              })
                            : _vm._e(),
                          _vm._v(
                            " " +
                              _vm._s(_vm.isEditMode ? "Update" : "Add") +
                              " "
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-modal",
        {
          attrs: { id: "viewModal", title: "View Expense", centered: "" },
          model: {
            value: _vm.showViewModal,
            callback: function ($$v) {
              _vm.showViewModal = $$v
            },
            expression: "showViewModal",
          },
        },
        [
          _c("p", [
            _c("strong", [_vm._v("Expense Date: ")]),
            _vm._v(_vm._s(_vm.selectedExpense.expenseDate)),
          ]),
          _c("p", [
            _c("strong", [_vm._v("Reference: ")]),
            _vm._v(_vm._s(_vm.selectedExpense.reference)),
          ]),
          _c("p", [
            _c("strong", [_vm._v("Total Amount: ")]),
            _vm._v(_vm._s(_vm.selectedExpense.total)),
          ]),
          _c("p", [
            _c("strong", [_vm._v("Currency: ")]),
            _vm._v(_vm._s(_vm.selectedExpense.currency)),
          ]),
          _c("p", [
            _c("strong", [_vm._v("Tax Amount: ")]),
            _vm._v(_vm._s(_vm.selectedExpense.taxAmount)),
          ]),
        ]
      ),
      _vm.expenseList.length === 0
        ? _c("h3", { staticClass: "text-center" }, [_vm._v("No Expense Data")])
        : _vm._e(),
      _vm.dataLoaded
        ? _c("b-table", {
            attrs: {
              items: _vm.expenseList,
              fields: _vm.fields,
              "current-page": _vm.currentPage,
              "per-page": _vm.perPage,
              "sort-by": _vm.sortBy,
              "sort-desc": _vm.sortDesc,
              responsive: "",
              striped: "",
            },
            on: {
              "update:sortBy": function ($event) {
                _vm.sortBy = $event
              },
              "update:sort-by": function ($event) {
                _vm.sortBy = $event
              },
              "update:sortDesc": function ($event) {
                _vm.sortDesc = $event
              },
              "update:sort-desc": function ($event) {
                _vm.sortDesc = $event
              },
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "cell(expenseDate)",
                  fn: function (row) {
                    return [
                      _vm._v(
                        " " + _vm._s(row.item.expenseDate.split("T")[0]) + " "
                      ),
                    ]
                  },
                },
                {
                  key: "cell(contact)",
                  fn: function (row) {
                    return [_vm._v(" " + _vm._s(row.item.contactName) + " ")]
                  },
                },
                {
                  key: "cell(actions)",
                  fn: function (row) {
                    return [
                      _c(
                        "b-dropdown",
                        {
                          attrs: {
                            variant: "link",
                            "toggle-class": "text-decoration-none",
                            "no-caret": "",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "button-content",
                                fn: function () {
                                  return [
                                    _c("feather-icon", {
                                      staticClass:
                                        "text-body align-middle mr-25",
                                      attrs: {
                                        icon: "MoreVerticalIcon",
                                        size: "16",
                                      },
                                    }),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            true
                          ),
                        },
                        [
                          _c(
                            "b-dropdown-item",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.openViewModal(row.item)
                                },
                              },
                            },
                            [
                              _c("feather-icon", {
                                staticClass: "mr-50",
                                attrs: { icon: "EyeIcon" },
                              }),
                              _c("span", [_vm._v("View")]),
                            ],
                            1
                          ),
                          _c(
                            "b-dropdown-item",
                            {
                              directives: [
                                {
                                  name: "b-modal",
                                  rawName: "v-b-modal.editModal",
                                  modifiers: { editModal: true },
                                },
                              ],
                              on: {
                                click: function ($event) {
                                  return _vm.openEditModal(row.item)
                                },
                              },
                            },
                            [
                              _c("feather-icon", {
                                staticClass: "mr-50",
                                attrs: { icon: "EditIcon" },
                              }),
                              _c("span", [_vm._v("Edit")]),
                            ],
                            1
                          ),
                          _c(
                            "b-dropdown-item",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.confirmDelete(row.item)
                                },
                              },
                            },
                            [
                              _c("feather-icon", {
                                staticClass: "mr-50",
                                attrs: { icon: "TrashIcon" },
                              }),
                              _c("span", [_vm._v("Delete")]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                },
              ],
              null,
              false,
              2561148333
            ),
          })
        : _c(
            "div",
            { staticClass: "text-center p-4" },
            [
              _c("b-spinner", {
                attrs: { variant: "primary", label: "Loading income data..." },
              }),
              _c("p", [_vm._v("Loading data, please wait...")]),
            ],
            1
          ),
      _c(
        "b-col",
        { attrs: { cols: "12" } },
        [
          _c("b-pagination", {
            staticClass: "my-0",
            attrs: {
              "total-rows": _vm.totalRows,
              "per-page": _vm.perPage,
              align: "center",
              size: "sm",
            },
            model: {
              value: _vm.currentPage,
              callback: function ($$v) {
                _vm.currentPage = $$v
              },
              expression: "currentPage",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }